import React, { useState } from "react";

import { doSignOut } from "./Firebase/firebase";
import Logo from "./Icons/Logo";
import { Link } from "gatsby";
import { useAuth } from "./Firebase/authContext";
import { DataLayerInteracyionType, pushToDataLayer } from "../utils/gtm";

const Header: React.FC = () => {
  const [menuVisible, setMenuVisible] = useState(false);
  const auth = useAuth();
  const toggleMenu = () => {
    if (auth && auth.user) {
      setMenuVisible(!menuVisible);
    } else {
      window.location.assign("/signIn/");
    }
  };

  const handleMenuClick = (action: string) => {
    setMenuVisible(false);
    if (action === "Logout") {
      pushToDataLayer({
        event: "button-signout-signout",
        category: DataLayerInteracyionType.Button,
        label: `Sign Out`,
      });
      doSignOut();
    }
    if (action === "Profile") {
      window.location.assign("/profile/");
    }
  };
  return (
    <header className="fixed w-[100%] bg-toolbar h-16 flex justify-between items-center px-4 text-secondary z-10">
      <div className="flex-none flex-col">
        <Link to={"/"} className="flex items-center">
          <Logo props={{ className: "h-[50px]", fill: "#fff" }} />
          <h2 className="ml-2">VRWorldSpace</h2>
        </Link>
      </div>

      {/* <div className="flex justify-center items-center w-full">
            <div className="flex w-3/5 bg-secondary rounded-3xl px-4 justify-center items-center h-[45px]">
              <div className="flex justify-between w-full">
                <div className="">
                  Search...
                </div>
                <div className="flex justify-between">
                  <span className="material-symbols-outlined ">search</span>
                </div>
              </div>
            </div>
          </div> */}

      <div className="flex flex px-1 relative items-center">
        <span className="hidden md:block">
          <Link
            to="/worlds"
            onClick={() => {
              pushToDataLayer({
                event: "button-menu-viewallworld",
                category: DataLayerInteracyionType.Button,
                label: "View All Worlds",
              });
            }}
            className="ml-8"
          >
            Worlds
          </Link>

          <Link
            to="/apply-world"
            onClick={() => {
              pushToDataLayer({
                event: "button-menu-submityourworld",
                category: DataLayerInteracyionType.Button,
                label: "Suggest A World",
              });
            }}
            className="ml-8"
          >
            Suggest A World
          </Link>

          <Link
            to="/tutorials"
            onClick={() => {
              pushToDataLayer({
                event: "button-menu-tutorial",
                category: DataLayerInteracyionType.Button,
                label: "Tutorials",
              });
            }}
            className="ml-8"
          >
            Tutorials
          </Link>
        </span>
        <span
          className=" material-symbols-outlined text-4xl ml-8 cursor-pointer"
          onClick={toggleMenu}
        >
          person
        </span>
        <span className="md:hidden  material-symbols-outlined text-4xl px-1">
          menu
        </span>

        {menuVisible && (
          <div className="absolute top-full right-0 bg-white shadow-md rounded-md py-2 mt-2">
            <div
              className="px-4 py-2 cursor-pointer hover:bg-gray-200"
              onClick={() => handleMenuClick("Profile")}
            >
              Profile
            </div>

            <div
              className="px-4 py-2 cursor-pointer hover:bg-gray-200"
              onClick={() => handleMenuClick("Logout")}
            >
              Logout
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
